import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./ai_studio/plugins/vuetify";
import { loadFonts } from "./ai_studio/plugins/webfontloader";
import router from "./ai_studio/router";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { createPinia } from 'pinia'
import RbSnackbar from '@/ai_studio/components/common/RbSnackbar.vue';

loadFonts();
const pinia = createPinia()
const app = createApp(App);
app.use(pinia)
app.component('RbSnackbar', RbSnackbar);
app.use(router).use(vuetify);

library.add(fas, far);
app.component('font-awesome-icon', FontAwesomeIcon);
app.config.globalProperties.$filters = {
  faIcon(value) {
    return ['fa', value];
  }
};
app.mount("#app");
